<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre3">Abbreviations</a></div>
<div class="SOM_pre"><a href="#/pre4">Introduction: The Global Religion</a></div>
<div class="SOM_chap"><a href="#/chap1">1 The Roots of Western Christian Identity Politics</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">2 The First Christians of Africa</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3 The Early Church in the Middle East</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4 The Beginning of Missions Along the Silk Road</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Conclusion: Following Jesus the Way He Made Us</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Timeline</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Image Credits</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Index of People</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Index of Places</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen12" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen13" title="Link target outside of Sample">Praise for <i>A Multitude of All Peoples</i></span></div>
<div class="SOM_appen"><span href="#/appen14" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?361f29a2